import * as React from 'react';
import { IProgressIndicatorProps } from './progress-indicator-props';
import { isIndeterminate, isDeterminate } from './utils';
import {
    ProgressIndicatorWrapper, ProgressBar,
    Progress, ProgressPercentage
} from './progress-indicator-parts';

interface IProgressIndicatorState {
    canRenderComponent: boolean;
}

export class ProgressIndicator extends React.PureComponent<IProgressIndicatorProps, IProgressIndicatorState> {

    static defaultProps: Partial<IProgressIndicatorProps> = {
        progress: 0,
        size: 'medium'
    };

    private timer?: number;

    constructor(props: IProgressIndicatorProps) {
        super(props);
        const canRenderComponent = this.canRenderComponent();
        this.state = {
            canRenderComponent
        };
    }

    componentDidUpdate(prevProps: IProgressIndicatorProps) {
        const { delay, hidden, progressIndicatorType } = this.props;
        if (prevProps.hidden === hidden
            && prevProps.progressIndicatorType === progressIndicatorType
            && prevProps.delay === delay) {
            return;
        }
        if (!hidden && delay && isIndeterminate(progressIndicatorType)) {
            this.showProgressBarAfterDelay();
            return;
        }
        this.updateViewState();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const { size, className } = this.props;
        const { canRenderComponent } = this.state;
        return canRenderComponent
            ? (
                <ProgressIndicatorWrapper className={className} size={size}>
                    {this.renderProgressBar()}
                    {this.renderProgressPercentage()}
                </ProgressIndicatorWrapper >
            ) : null;
    }

    private renderProgressBar() {
        const { progress, progressIndicatorType, showPercentage } = this.props;
        return (
            <ProgressBar showPercentage={showPercentage} progressIndicatorType={progressIndicatorType}>
                <Progress progress={progress} progressIndicatorType={progressIndicatorType} />
            </ProgressBar>
        );
    }

    private renderProgressPercentage() {
        const { progress, showPercentage, progressIndicatorType } = this.props;
        return showPercentage && isDeterminate(progressIndicatorType) ? (
            <ProgressPercentage>{progress}%</ProgressPercentage>
        ) : null;
    }

    private canRenderComponent() {
        const { hidden, delay, progressIndicatorType } = this.props;
        let canRenderComponent = !hidden;
        if (canRenderComponent && delay && isIndeterminate(progressIndicatorType)) {
            canRenderComponent = false;
            this.showProgressBarAfterDelay();
        }
        return canRenderComponent;
    }

    private showProgressBarAfterDelay() {
        const { delay } = this.props;
        clearTimeout(this.timer);
        this.timer = setTimeout(this.updateViewState, delay);
    }

    private updateViewState = () => {
        const { hidden } = this.props;
        this.setState({
            canRenderComponent: !hidden
        });
    }
}
